import React from "react";
import Autocomplete from '@mui/material/Autocomplete';
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CircularProgress from '@mui/material/CircularProgress';
import InputAdornment from '@mui/material/InputAdornment';
import EditIcon from '@mui/icons-material/Edit';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import ReactDataSheet from 'react-datasheet';
import './react-datasheet.css';
import cloneDeep from 'lodash.clonedeep';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import LinearProgress from '@mui/material/LinearProgress';

import { withStyles } from "@mui/styles";
import { authFetch, authPost, authPostFile } from "../../authProvider";

import { ConfirmCancelDialog } from '../ConfirmCancelDialog';
import { LanguageContext } from '../LanguageContext';
import LocalizedDatePicker from "../LocalizedDatePicker";

const defaultToolbarStyles = {
    iconButton: {},
};

const ROW_NUM = 20; // grid rows

const initGrid = (cols, rows) => {
    //Initialize Grid
    const grid = [];

    grid.push((cols || []).map(d => ({ value: d, readOnly: true, width: 200, className: "kulutus-bulk-input-header" })));

    for (let i = 0; i < rows; i++) {
        const arr = [];
        for (let j = 0; j < cols.length; j++) {
            arr.push({ value: "", width: 200, className: "kulutus-bulk-input-row" });
        }
        grid.push(arr);
    }

    return grid;
}


class KulutusAddBulk extends React.Component {
    static contextType = LanguageContext;
    constructor(props) {
        super(props);

        this.fileInputRef = React.createRef();

        this.state = {
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            RiviAvain: null,
            KustannuspaikkaAvain: null,
            TapahtumaAika: null,
            Tuoteryhma: null,
            Tuotenimi: null,
            Yritys: null,
            Selite: null,
            Maara: null,
            Euro: null,
            CO2: null,
            KulutusTyyppi: null,
            Yksikko: null,
            Created: null,
            Updated: null,
            Username: null,
            kulutukset: (Object.keys(props.lookupLists.kulutukset).map((d) => ({ value: d, label: props.lookupLists.kulutukset[d] })) || []),
            kustannuspaikat: (Object.keys(props.lookupLists.kustannuspaikat).map((d) => ({ value: d, label: props.lookupLists.kustannuspaikat[d] })) || []),
            loadingSave: false,
            loadingDelete: false,
            grid: [],
            template: null,
            // File upload states
            uploading: false,
            uploadProgress: 0,
            uploadError: null,
            uploadSuccess: null,
            selectedFile: null
        };
    }

    handleClearData = () => {
        this.setState({
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            RiviAvain: null,
            KustannuspaikkaAvain: null,
            TapahtumaAika: null,
            Tuoteryhma: null,
            Tuotenimi: null,
            Yritys: null,
            Selite: null,
            Maara: null,
            Euro: null,
            CO2: null,
            KulutusTyyppi: null,
            Yksikko: null,
            Created: null,
            Updated: null,
            Username: null
        });
    }

    handleSave = () => {
        const { template } = this.state;
        const json = (this.state.grid || []).slice(1).map(arr => (arr || []).map(d => ({ value: d.value })));

        this.props.onAddNewRows({
            json
        }, template);

        this.handleClear();
        this.handleClearData();
    };

    handleClear = () => {
        const { dictionary } = this.context;

        const cols = dictionary.DataIngestion.Kulutus.Template.Columns[this.state.template || 0];

        this.setState({
            open: true,
            grid: initGrid(cols, ROW_NUM)
        });
    };

    handleClose = () => {
        if (this.state.jotainMuuttui) {
            this.setState({
                setOpen: true
            });
        }
        else {
            this.setState({
                open: false,
                setOpen: false
            });
        }
    }

    handleSetOpenCancel = () => {
        this.setState({
            open: true,
            setOpen: false
        });
    }

    handleTemplateChange = (event, newValue) => {
        this.setState({
            template: newValue ? newValue.value : null,
        }, () => {
            this.handleClear();
        });
    };

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
            jotainMuuttui: true
        });
    };

    handleChangeDate = (name, value) => {
        this.setState({
            [name]: value,
            jotainMuuttui: true
        });
    };

    handleClickOpen = () => {
        this.setState({
            open: true,
            grid: []
        });
    }

    handleFilePick = (event) => {
        const file = (event.target.files || [])[0];
        if (!file) return;
        this.processFile(file);
    };


    processFile = (file) => {
        // Clear previous states
        this.setState({
            uploadError: null,
            uploadSuccess: null,
            selectedFile: file
        });

        const allowedTypes = [
            'text/csv',
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        ];
        
        const { dictionary } = this.context;
        
        if (!allowedTypes.includes(file.type)) {
            this.setState({ 
                uploadError: dictionary.DataIngestion.Kulutus.Template.Upload.FileTypeError
            });
            return;
        }
        
        if (file.size > 10 * 1024 * 1024) {
            this.setState({ 
                uploadError: dictionary.DataIngestion.Kulutus.Template.Upload.FileSizeError
            });
            return;
        }

        this.uploadFile(file);
        // reset input so same file can be picked again
        if (this.fileInputRef.current) this.fileInputRef.current.value = '';
    };

    uploadFile = async (file) => {
        this.setState({ 
            uploading: true, 
            uploadProgress: 0,
            uploadError: null,
            uploadSuccess: null
        });

        const formData = new FormData();
        formData.append('file', file);

        try {
            // Simulate progress for better UX
            const progressInterval = setInterval(() => {
                this.setState(prevState => ({
                    uploadProgress: Math.min(prevState.uploadProgress + 10, 90)
                }));
            }, 200);

            const response = await authPostFile(this.props.pca, '/api/DataIngestion/Kulutus/Upload/' + this.state.template, {
                body: formData
            });

            clearInterval(progressInterval);
            this.setState({ uploadProgress: 100 });

            const { dictionary } = this.context;
            
            if (response.ok) {
                const result = await response.json();
                this.setState({ 
                    uploadSuccess: result.message || dictionary.DataIngestion.Kulutus.Template.Upload.UploadSuccess,
                    uploading: false
                });
                
                // Call the parent component to refresh data
                if (this.props.onAddNewRows) {
                    this.props.onAddNewRows({ success: true, message: result.message });
                }
                
                // Auto close after success
                setTimeout(() => {
                    this.handleClose();
                }, 2000);
            } else {
                const error = await response.json();
                this.setState({ 
                    uploadError: error.message || dictionary.DataIngestion.Kulutus.Template.Upload.UploadError,
                    uploading: false,
                    uploadProgress: 0
                });
            }
        } catch (e) {
            const { dictionary } = this.context;
            this.setState({ 
                uploadError: dictionary.DataIngestion.Kulutus.Template.Upload.NetworkError + ': ' + e.message,
                uploading: false,
                uploadProgress: 0
            });
        }
    };


    render() {
        const { dictionary } = this.context;
        const { 
            open, 
            uploading, 
            uploadProgress, 
            uploadError, 
            uploadSuccess, 
            selectedFile
        } = this.state;

        return (
            <React.Fragment>
                <Tooltip title={dictionary.Toolbar.NewRow}>
                    <IconButton onClick={this.handleClickOpen}>
                        <AddBoxOutlinedIcon />
                    </IconButton>
                </Tooltip>

                <Dialog
                    open={open}
                    fullWidth
                    maxWidth="lg"
                >
                    <DialogTitle>{dictionary.DataIngestion.Kulutus.Title}</DialogTitle>
                    <DialogContent>
                        <Box sx={{ display: "flex", mb: 2 }}>
                            <Box sx={{ display: "flex" }}>
                                <Autocomplete
                                    onChange={(event, newValue) => this.handleTemplateChange(event, newValue)}
                                    options={(dictionary.DataIngestion.Kulutus.Template.Options || []).map((d, i) => ({ label: d, value: i }))}
                                    style={{ width: 400, marginTop: 8 }}
                                    isOptionEqualToValue={(option, value) => option.value === value.value}
                                    renderInput={(params) => <TextField
                                        {...params}
                                        variant="outlined"
                                        label={dictionary.DataIngestion.Kulutus.Template.Hint}
                                    />}
                                />
                            </Box>
                            <Box sx={{ flexGrow: 1 }}>
                            </Box>
                            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                <input
                                    ref={this.fileInputRef}
                                    accept=".csv,.xlsx,.xls"
                                    style={{ display: 'none' }}
                                    type="file"
                                    onChange={this.handleFilePick}
                                />
                                <Button
                                    variant="outlined"
                                    onClick={() => this.fileInputRef.current && this.fileInputRef.current.click()}
                                    startIcon={<CloudUploadIcon />}
                                    disabled={uploading || this.state.template === null}
                                    sx={{ mr: 1 }}
                                >
                                    {uploading ? dictionary.DataIngestion.Kulutus.Template.Upload.Uploading : dictionary.DataIngestion.Kulutus.Template.Upload.UploadButton}
                                </Button>
                                <ButtonGroup variant="comboButton">
                                    <Button
                                        variant="Secondary"
                                        onClick={this.handleClear}
                                        disabled={uploading}
                                    >
                                        {dictionary.Clear}
                                    </Button>
                                    <Button
                                        variant="Primary"
                                        onClick={this.handleSave}
                                        disabled={uploading}
                                    >
                                        {dictionary.Save}
                                    </Button>
                                </ButtonGroup>
                            </Box>
                        </Box>

                        {uploading && (
                            <Box sx={{ mb: 2 }}>
                                <Typography variant="body2" gutterBottom>
                                    {dictionary.DataIngestion.Kulutus.Template.Upload.UploadingFile}
                                </Typography>
                                <LinearProgress 
                                    variant="determinate" 
                                    value={uploadProgress} 
                                    sx={{ mb: 1 }}
                                />
                                <Typography variant="caption" color="text.secondary">
                                    {uploadProgress}% {dictionary.DataIngestion.Kulutus.Template.Upload.ProgressComplete}
                                </Typography>
                            </Box>
                        )}

                        {uploadError && (
                            <Alert severity="error" sx={{ mb: 2 }}>
                                {uploadError}
                            </Alert>
                        )}

                        {/* Selected File Info */}
                        {selectedFile && !uploading && (
                            <Box sx={{ mb: 2 }}>
                                <Typography variant="body2" color="text.secondary">
                                    {dictionary.DataIngestion.Kulutus.Template.Upload.SelectedFile}: <strong>{selectedFile.name}</strong> ({(selectedFile.size / 1024 / 1024).toFixed(2)} MB)
                                </Typography>
                            </Box>
                        )}

                        <Box sx={{ mb: 2 }}>
                            <Typography variant="body2">
                                {(dictionary.DataIngestion.Kulutus.Template.Texts || []).map((d, i) => (
                                    <React.Fragment key={i}>{d}<br /></React.Fragment>
                                ))}
                            </Typography>
                        </Box>
                        
                        <ReactDataSheet
                            data={this.state.grid}
                            valueRenderer={cell => cell.value}
                            onCellsChanged={changes => {
                                const grid = this.state.grid.map(row => [...row]);
                                changes.forEach(({ cell, row, col, value }) => {
                                    grid[row][col] = { ...grid[row][col], value };
                                });
                                this.setState({ grid });
                            }}
                        />
                    </DialogContent>
                    <DialogActions
                        style={{ backgroundColor: "#3C495A" }}
                    >
                        <ButtonGroup variant="comboButton">
                            <Button variant="Secondary" onClick={this.handleClose} disabled={uploading}>
                                {dictionary.Close}
                            </Button>
                            <Button variant="Primary" onClick={this.handleSave} disabled={uploading}>
                                {dictionary.Save}
                            </Button>
                        </ButtonGroup>
                    </DialogActions>
                </Dialog>
                <ConfirmCancelDialog
                    open={this.state.setOpen}
                    onCancel={this.handleSetOpenCancel}
                    onOk={this.handleClearData}
                />
            </React.Fragment>
        );
    }
}


export default withStyles(defaultToolbarStyles, { name: "KulutusAddBulk" })(KulutusAddBulk);